<template>
  <!-- "Kā tas strādā" — the change is small: three steps, no install, no website change (spec §3.3),
       with the client's view on a phone next to them (§13.2: replaces the separate phone section).
       No time per step: nothing was measured. -->
  <v-container fluid class="py-14 as-home-section as-home-section--grey">
    <v-row justify="center">
      <v-col cols="12" md="10" lg="9">
        <h2 class="as-home-heading">{{ $t('pages.home-view.how-it-works.title') }}</h2>
        <p class="as-home-subheading">{{ $t('pages.home-view.how-it-works.subtitle') }}</p>

        <v-row align="center">
          <v-col cols="12" md="7">
            <div v-for="(step, index) in steps" :key="step" class="as-home-step">
              <div class="as-home-step__top">
                <div class="as-home-step__number" aria-hidden="true">{{ index + 1 }}</div>
                <h3 class="as-home-step__title">{{ $t(`pages.home-view.how-it-works.steps.${step}.title`) }}</h3>
              </div>
              <p class="as-home-step__text">{{ $t(`pages.home-view.how-it-works.steps.${step}.text`) }}</p>
            </div>
          </v-col>
          <v-col cols="12" md="5" class="text-center">
            <img src="/img/mobile_3.png" :alt="$t('pages.home-view.how-it-works.phone-alt')" class="as-home-step__phone" />
          </v-col>
        </v-row>

        <div class="as-home-cta-row">
          <v-btn color="var(--color-pallet-1)" dark x-large rounded elevation="2" @click="$emit('start')">
            {{ $t('pages.home-view.cta.start-free') }}
          </v-btn>
          <v-btn outlined color="var(--color-pallet-1)" x-large rounded target="_blank" :href="exampleUrl" @click="$emit('see-example')">
            {{ $t('pages.home-view.cta.see-example') }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/** Self-service, not "pay": payments are optional (Ansis, 2026-10-25). */
const STEPS = ['create', 'share', 'self-service']

export default {
  name: 'HomeHowItWorksSection',
  props: {
    /** Localized URL of the example studio page. */
    exampleUrl: { type: String, required: true }
  },
  data: () => ({
    steps: STEPS
  })
}
</script>

<style>
.as-home-step {
  background: var(--color-white);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

/* Number and title on one line, so a phone does not spend a line on the number alone. */
.as-home-step__top {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.as-home-step__phone {
  max-width: 240px;
  width: 65%;
  height: auto;
}

.as-home-step__number {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--color-pallet-1);
  color: var(--color-white);
  font-weight: 700;
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.as-home-step__title {
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.3;
  color: var(--color-pallet-5);
  margin: 0;
  min-width: 0;
  overflow-wrap: anywhere;
}

.as-home-step__text {
  color: var(--color-pallet-2);
  line-height: 1.6;
  margin-bottom: 0;
  overflow-wrap: anywhere;
}
</style>
